export const ENTITY_TYPE = Object.freeze({
  machineLearning: 'simple',
  list: 'list',
  regexp: 'regex',
  patternAny: 'patternany',
  prebuilt: 'prebuilt'
})

export const ENTITY_NAMES = Object.freeze({
  [ENTITY_TYPE.machineLearning]: 'Machine Learning',
  [ENTITY_TYPE.list]: 'List',
  [ENTITY_TYPE.regexp]: 'RegExp',
  [ENTITY_TYPE.patternAny]: 'Pattern Any',
  [ENTITY_TYPE.prebuilt]: 'Prebuilt'
})

export const getEntityTypeLabel = entityType => {
  switch (entityType) {
    case ENTITY_TYPE.patternAny: {
      return '{p}'
    }
    case ENTITY_TYPE.machineLearning: {
      return 'ML'
    }
    case ENTITY_TYPE.regexp: {
      return '(.*)'
    }
    case ENTITY_TYPE.prebuilt: {
      return '(|)'
    }
    case ENTITY_TYPE.list: {
      return '[ ]'
    }
    default:
      return entityType
  }
}

export const entityTypesOptions = [
  {
    label: ENTITY_NAMES[ENTITY_TYPE.machineLearning],
    value: ENTITY_TYPE.machineLearning
  },
  {
    label: ENTITY_NAMES[ENTITY_TYPE.list],
    value: ENTITY_TYPE.list
  },
  {
    label: ENTITY_NAMES[ENTITY_TYPE.regexp],
    value: ENTITY_TYPE.regexp
  },
  {
    label: ENTITY_NAMES[ENTITY_TYPE.patternAny],
    value: ENTITY_TYPE.patternAny
  },
  {
    label: ENTITY_NAMES[ENTITY_TYPE.prebuilt],
    value: ENTITY_TYPE.prebuilt
  }
]
